module.exports = __webpack_public_path__ + "static/media/Right.65b30d5e.svg";